import React from "react";
import Header from "../components/layout/Header";
import Form from "../components/features/Form";
import Footer from "../components/layout/Footer";
import BackgroundVideo from "../components/layout/BackgroundVideo";
import { Helmet } from "react-helmet-async";

const Home = () => {
  return (
    <>
      <Helmet>
      </Helmet>
      <div className="relative flex flex-col min-h-screen w-full font-body">
        {/* Video de fondo */}
        <BackgroundVideo />

        {/* Contenido principal */}
        <div className="relative flex flex-col min-h-screen w-full items-center justify-between">
          <Header />

          {/* Contenedor del formulario */}
          <div className="w-[92%] sm:w-[85%] md:w-[70%] lg:w-[50%] xl:w-[40%] max-w-3xl 
            bg-[#F5F9FC] bg-opacity-30 dark:bg-[#1C1C1C] dark:bg-opacity-30 
            text-[#779ED3] dark:text-[#F5F9FC] 
            p-6 md:p-8 rounded-lg shadow-lg mt-8 sm:mt-14 ">
            <Form />
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
};

export default Home;
